module.exports = __webpack_public_path__ + "static/media/7x7GoodOptimized.6a65d20c.jp2";